<template>
    <requisicao-form
        operacao="I"
        @salvar="salvar($event)"
        :errosPai="erros"
    ></requisicao-form>
</template>
<script>
import RequisicaoForm from './RequisicaoForm'
import RequisicoesServicos from './RequisicoesServicos'

export default {
    data() {
        return {
            erros: []
        }
    },

    methods: {
        salvar(requisicao) {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.inserirRequisicao(requisicao).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.toDetalhar(response.data)
                            this.$store.dispatch('setRecarregar', true)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        toDetalhar(idRequisicao) {
            this.$router.push({
                name: 'Contratos_Requisicoes_Detalhar',
                params: {
                    idRequisicao: idRequisicao
                }
            })
        }
    },

    components: {
        RequisicaoForm
    }
}
</script>